import { data } from '../../svg/FileCopy/data';
import { makeIcon } from '../makeIcon';

export const FileCopy = makeIcon(data, 'file_copy', 'FileCopy');

export default FileCopy;
